<div class="container">
    <div class="row">
        <div class="col-md-12">
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>
                        Title
                    </th>
                    <th>
                        Actions
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let section of sections">
                    <td>{{section.title}}</td>
                    <td>
                        <button class="btn btn-xs btn-info" type="button" (click)="edit(section)">Edit</button>&nbsp;
                        <button class="btn btn-xs btn-warning" type="button" (click)="delete(section.id)">Delete</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-10">
    </div>
    <div class="col-md-2 text-right">
        <button class="btn btn-info" (click)="newSection()">New Section</button>
    </div>
</div>

<div>
    <accordion>
        <accordion-group panelClass="b0 mb-2" [isOpen]="isFormOpen">
            <form [formGroup]="sectionFormGroup" class="form-validate form-horizontal" #mainForm="ngForm" (submit)="submitForm(mainForm)">
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Title</label>
                    <div class="col-md-9">
                        <input class="form-control" type="text" formControlName="title"/>
                        <span class="text-danger" *ngIf="sectionFormGroup.controls['title'].hasError('required') && (sectionFormGroup.controls['title'].dirty || sectionFormGroup.controls['title'].touched||mainForm.submitted)">This field is required</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-2"></div>
                    <div class="col-md-10">
                        <button type="submit" class="btn btn-secondary">Save</button>
                    </div>
                </div>
            </form>
        </accordion-group>
    </accordion>
</div>
